import { WATERMARK_BASE64 } from '@shared/matrix/const';
import logger from '@shared/utils/error/logger';
const Supported_Image_Formats = 'image/jpeg,image/jpg,image/png';

/**
 * @description: Convert a file object to a data URL
 * @param {File} file
 * @return {Promise<string>}
 */
export const fileToDataUrl = async (file: File): Promise<string> => {
	// const res = await new Promise<string>((resolve, reject) => {
	// 	if (typeof FileReader !== 'undefined') {
	// 		console.log('[cjj] fileInfo', file, file.type, file.size);
	// 		const reader = new FileReader();
	// 		// reader.onload = () => {
	// 		// 	resolve(reader.result as string);
	// 		// 	console.log('🚀🚀🚀 ~ onload:');
	// 		// };
	// 		// reader.onerror = (error) => {
	// 		// 	logger.error('upload error', 'FileReader onerror', {
	// 		// 		error: error,
	// 		// 		fileName: file.name,
	// 		// 		fileSize: file.size,
	// 		// 		fileType: file.type,
	// 		// 	});
	// 		// 	reject(new Error(`FileReader failed: ${error}`));
	// 		// };
	// 		// reader.readAsDataURL(file);
	// 	} else {
	// 		logger.error('upload error', 'FileReader does not exist', 'fileToDataUrl');
	// 		reject(new Error('❌FileReader does not exist'));
	// 	}
	// });
	// return res;

	const arrayBuffer = await file.arrayBuffer();
	const uint8Array = new Uint8Array(arrayBuffer);
	let binary = '';
	for (let i = 0; i < uint8Array.length; i++) {
		binary += String.fromCharCode(uint8Array[i]);
	}
	return 'data:' + file.type + ';base64,' + btoa(binary);
};

const getFileInfos = (file: File) => {
	const dotIdx = file.name.lastIndexOf('.');
	const suffix = file.name.slice(dotIdx + 1).toLowerCase();
	const fileName = file.name.slice(0, dotIdx);
	return {
		suffix,
		fileName,
	};
};

/**
 * 获取图片压缩后数据
 * @param file
 * @returns 压缩后图片的信息
 */
const getCompressedData = (
	file: File,
	suffix?: 'png' | 'jpeg' | 'webp',
): { fileName: string; type: 'image/png' | 'image/jpeg' | 'image/webp' } => {
	const { fileName, suffix: fileSuffix } = getFileInfos(file);
	if (suffix) {
		return {
			fileName: `${fileName}.${suffix}`,
			type: `image/${suffix}`,
		};
	}
	const newFileSuffix = fileSuffix === 'png' ? 'png' : 'jpg';
	const newFileType = fileSuffix === 'png' ? 'image/png' : 'image/jpeg';
	return {
		fileName: `${fileName}.${newFileSuffix}`,
		type: newFileType,
	};
};

/**
 * @description: Convert a File object to an ImageElement
 * @param {File} file
 * @return {*}
 */
export const fileToImgElement = async (
	file: File,
	fileName: string,
	type: string,
): Promise<HTMLImageElement> => {
	let newFile = file;
	if (!Supported_Image_Formats.includes(file.type)) {
		newFile = new File([file], fileName, {
			type,
		});
	}
	const dataUrl = await fileToDataUrl(newFile);

	const imgElement = document.createElement('img');
	imgElement.src = dataUrl;
	try {
		await imgElement.decode();
	} catch (error) {
		logger.error('util', 'Image decode failed', { error: String(error) });
		// 不抛出错误，继续使用 imgElement
	}

	// 验证图片是否有效
	if (imgElement.naturalWidth === 0 || imgElement.naturalHeight === 0) {
		logger.error('upload error', 'Invalid image dimensions', {
			width: imgElement.naturalWidth,
			height: imgElement.naturalHeight,
		});
	}
	return imgElement;
};

/**
 * @description: Convert canvas to data URL
 * @param {HTMLCanvasElement} canvas
 * @return {string} The data URL representing the content of the canvas
 */
export const canvasToDataUrl = (canvas: HTMLCanvasElement) => {
	const canvasDataURL = canvas.toDataURL('image/png', 1);
	return canvasDataURL;
};

/**
 * @description: Convert a data URL to a File object.
 * @param {string} url - The data URL to convert.
 * @param {string} filename - The desired filename for the File object.
 * @returns {File} - The converted File object.
 */
export const dataURLtoFile = (url: string, filename: string): File => {
	const arr = url.split(',');
	const mime = arr[0].match(/:(.*?);/)?.[1];
	const bstr = atob(arr[1]);
	const u8arr = new Uint8Array(bstr.length);

	for (let i = 0, len = bstr.length; i < len; i++) {
		u8arr[i] = bstr.charCodeAt(i);
	}

	return new File([u8arr], filename, { type: mime });
};

/**
 * @description: Click to download
 *  * @param {File} file
 * @param {string} name - Default value is 'a1.art'
 * @return {*}
 */
export const downloadByClick = (file: File, name = 'a1.art'): void => {
	const a = document.createElement('a');
	a.download = name;
	a.style.display = 'none';
	const url = URL.createObjectURL(file);
	a.href = url;
	document.body.appendChild(a);
	a.click();
	URL.revokeObjectURL(url);
	document.body.removeChild(a);
};

interface I_CompressFileOld {
	file: File;
	maxW?: number;
	maxH?: number;
	suffix?: 'png' | 'jpeg' | 'webp';
}

interface I_CompressFile {
	file: File;
	maxW?: number;
	maxH?: number;
	suffix?: 'png' | 'jpeg' | 'webp';
	quality?: number;
	removeAlpha?: boolean;
	backgroundColor?: string;
}

/**
 * @description: 图片压缩
 * @param {I_CompressFileOld } param0
 */
export const compressFileOld = async ({
	file,
	maxW = 2048,
	maxH = 2048,
	suffix,
}: I_CompressFileOld): Promise<File> => {
	try {
		const { fileName, type } = getCompressedData(file, suffix);
		const imgEl = await fileToImgElement(file, fileName, type);

		const { width, height } = imgEl;
		if (!width || !height) {
			throw new Error(`Invalid image width and height. fileName: ${file?.name}`);
		}
		const ratio_w = width / maxW,
			ratio_h = height / maxH;
		let canvasW = 0,
			canvasH = 0;
		if (width <= maxW && height <= maxH) {
			canvasW = width;
			canvasH = height;
		} else {
			if (ratio_w >= ratio_h) {
				canvasW = Math.floor(width / ratio_w);
				canvasH = Math.floor(height / ratio_w);
			} else {
				canvasW = Math.floor(width / ratio_h);
				canvasH = Math.floor(height / ratio_h);
			}
		}

		const canvas = document.createElement('canvas');
		(canvas.width = canvasW), (canvas.height = canvasH);

		const context2d = canvas.getContext('2d');
		if (!context2d) {
			logger.error('upload error', 'Failed to get canvas 2D context', null);
			throw new Error('Failed to get canvas 2D context');
		}

		try {
			context2d.drawImage(imgEl, 0, 0, width, height, 0, 0, canvasW, canvasH);
		} catch (drawError) {
			logger.error('upload error', 'drawImage failed', { error: String(drawError) });
			throw new Error(`drawImage failed: ${drawError}`);
		}
		const blob = (await canvasToFile(canvas, type)) as Blob;
		if (!blob) {
			logger.error('upload error', 'canvasToFile returned null blob', null);
			throw new Error('Failed to convert canvas to blob');
		}

		const newFile = await new File([blob], fileName, {
			type,
		});

		return newFile;
	} catch (error) {
		logger.error('upload error', 'compressFile failed', {
			error: error,
			errorMessage: error instanceof Error ? error.message : String(error),
			errorStack: error instanceof Error ? error.stack : undefined,
			fileName: file?.name,
			fileSize: file?.size,
			fileType: file?.type,
		});
		return file;
	}
};

/**
 * @description: 新版图片压缩，默认缩放到 1024 内、导出 jpeg、去除 Alpha 通道
 * @param {I_CompressFile } param0
 */
export const compressFile = async ({
	file,
	maxW = 1024,
	maxH = 1024,
	suffix,
	quality = 0.78,
	removeAlpha = true,
	backgroundColor = '#FFFFFF',
}: I_CompressFile): Promise<File> => {
	try {
		const outputSuffix = suffix ?? 'jpeg';
		const { fileName, type } = getCompressedData(file, outputSuffix);
		const imgEl = await fileToImgElement(file, fileName, type);

		const { width, height } = imgEl;
		if (!width || !height) {
			throw new Error(`Invalid image width and height. fileName: ${file?.name}`);
		}

		const ratio_w = width / maxW,
			ratio_h = height / maxH;
		let canvasW = 0,
			canvasH = 0;
		if (width <= maxW && height <= maxH) {
			canvasW = width;
			canvasH = height;
		} else if (ratio_w >= ratio_h) {
			canvasW = Math.floor(width / ratio_w);
			canvasH = Math.floor(height / ratio_w);
		} else {
			canvasW = Math.floor(width / ratio_h);
			canvasH = Math.floor(height / ratio_h);
		}

		const canvas = document.createElement('canvas');
		canvas.width = canvasW;
		canvas.height = canvasH;

		const context2d = canvas.getContext('2d');
		if (!context2d) {
			logger.error('upload error', 'Failed to get canvas 2D context', null);
			throw new Error('Failed to get canvas 2D context');
		}

		if (removeAlpha) {
			context2d.fillStyle = backgroundColor;
			context2d.fillRect(0, 0, canvasW, canvasH);
		}

		try {
			context2d.drawImage(imgEl, 0, 0, width, height, 0, 0, canvasW, canvasH);
		} catch (drawError) {
			logger.error('upload error', 'drawImage failed', { error: String(drawError) });
			throw new Error(`drawImage failed: ${drawError}`);
		}

		const blob = await canvasToFile(canvas, type, quality);
		if (!blob) {
			logger.error('upload error', 'canvasToFile returned null blob', null);
			throw new Error('Failed to convert canvas to blob');
		}

		return new File([blob], fileName, { type });
	} catch (error) {
		logger.error('upload error', 'compressFile1 failed', {
			error: error,
			errorMessage: error instanceof Error ? error.message : String(error),
			errorStack: error instanceof Error ? error.stack : undefined,
			fileName: file?.name,
			fileSize: file?.size,
			fileType: file?.type,
		});
		return file;
	}
};

const canvasToFile = async (
	canvas: HTMLCanvasElement,
	fileType: string = 'image/jpeg',
	quality = 0.5,
): Promise<Blob | null> => {
	return new Promise((resolve) => {
		try {
			canvas.toBlob(
				(blob) => {
					if (blob) {
						resolve(blob);
					} else {
						logger.error('upload error', 'canvasToFile failed: blob is null', null);
						resolve(null);
					}
				},
				fileType,
				quality,
			);
		} catch (error) {
			logger.error('upload error', 'canvasToFile error', { error: String(error) });
			resolve(null);
		}
	});
};
/**
 * Downloads an image from a given URL and saves it with a specified name.
 * If a callback function is provided, it will be called after the image is downloaded.
 * @param {string} url - The URL of the image to download.
 * @param {string} name - The name to save the downloaded image as.
 * @param {AnyFunc} cb - An optional callback function to be called after the image is downloaded.
 * @return {*}
 */
export function downloadByUrl(
	url: string,
	data: { appName: string; watermarkProps?: WatermarkProps },
	cb?: () => void,
) {
	const watermarkedUrl = addWatermarkToImage(url, data.watermarkProps);

	const image = new Image();
	image.setAttribute('crossOrigin', 'anonymous');
	image.setAttribute('referrerpolicy', 'no-referrer');
	image.onload = function () {
		const canvas = document.createElement('canvas');
		canvas.width = image.width;
		canvas.height = image.height;

		const context = canvas.getContext('2d')!;
		context.drawImage(image, 0, 0, image.width, image.height);

		const ext = url.includes('format/webp') ? 'webp' : url.split('.').reverse()[0];
		const mimeType = ext === 'png' ? 'image/png' : ext === 'webp' ? 'image/webp' : 'image/jpeg';
		const dataUrl = canvas.toDataURL(mimeType);

		const anchor = document.createElement('a');
		const imgName = `${data.appName.substring(0, 30)}_A1.art_.${ext}` || 'photo';
		anchor.download = imgName;
		anchor.target = '_blank';
		anchor.href = dataUrl;
		anchor.click();
		cb?.();
	};

	image.src = watermarkedUrl;
}

/**
 * 阿里云图片压缩
 */
export type AllowedDy = '5' | '16' | '20' | '30' | '40';

interface imgTransformParams {
	format?: 'jpg' | 'png' | 'webp' | 'bmp' | 'gif' | 'tiff' | 'heic' | 'avif';
	resize?: '100' | '200' | '300' | '360' | '500' | '700' | '900' | '512' | '800'; //图片宽度 W_200
	quality?: string; //图片质量 Q_100
	interlace?: '0' | '1'; // 控制渐进式加载
	watermarkProps?: {
		dy?: string; //距离底部距离
		resize?: string; //水印缩放
	}; //水印
}

/**
 *
 * @desc 注意：不同图片压缩尺寸对应的水印参数位置不同
 * 100对应dy=5
 * 300对应dy=16
 * 360对应dy=20
 * 500对应dy=30
 * 700对应dy=40
 */
export const compressImage = (url?: string, params?: imgTransformParams) => {
	if (!url || typeof url !== 'string') return '';
	if (url.endsWith('.mp4') || url.endsWith('.gif')) return url;
	//前置判断处理base64url
	const reg = RegExp(/data:image\/.*;base64,/);
	const isBaseUrl = reg.test(url);
	if (isBaseUrl) return url;

	// 是否已经压缩过 || 本地文件
	if (url.includes('?') || url.startsWith('blob')) return url;

	const defaultParams = {
		format: 'webp',
	};

	const _params = Object.assign(defaultParams, params || {});

	let compressedUrl = url + `?imageMogr2/format/${_params.format}`;
	if (_params.resize) {
		compressedUrl += `/thumbnail/${_params.resize}x/quality/60/interlace/${_params.interlace || 0}`;
	}
	// 添加水印逻辑 (这里的resize是水印的大小)
	if (_params.watermarkProps) {
		const { dy = '10', resize = '300' } = _params.watermarkProps;

		// 固定水印地址的 Base64 编码形式
		compressedUrl += `|watermark/1/image/${WATERMARK_BASE64}/dissolve/100/dx/0/dy/${dy}/gravity/south/scatype/1/spcent/${resize}`;
	}
	return compressedUrl;
};

export interface WatermarkProps {
	dy?: string;
	resize?: string;
}

export const addWatermarkToImage = (url?: string, watermarkProps?: WatermarkProps): string => {
	if (!url || typeof url !== 'string') return '';
	if (!watermarkProps) return url;
	// 前置处理：本地、已加参数的 URL、base64、视频和 gif 不处理
	const isBase64 = /^data:image\/.*;base64,/.test(url);
	const hasQuery = url.includes('?');
	const isBlob = url.startsWith('blob');
	const isVideo = url.endsWith('.mp4') || url.endsWith('.gif');
	const hasWatermark = url.includes('watermark');
	if (isBase64 || hasQuery || isBlob || isVideo || hasWatermark) {
		return url;
	}
	// 去除已有的查询参数
	const [baseUrl] = url.split('?');
	const { dy = '10', resize = '300' } = watermarkProps || {};
	return `${baseUrl}?watermark/1/image/${WATERMARK_BASE64}/dissolve/100/dx/0/dy/${dy}/gravity/south/scatype/1/spcent/${resize}`;
};

/**
 * 根据压缩图的 watermark.dy 和尺寸比例，换算出原图对应的 dy。
 *
 * @param originalSize 原图尺寸 { width, height }
 * @param compressedWidth 压缩图宽度（默认为 360）
 * @param compressedDy 压缩图 watermark 的 dy（字符串或数字）
 * @returns 原图应该使用的 dy（字符串，保留两位小数）
 */
export function convertWatermarkDyToOriginal(
	originalSize: { width: number; height: number },
	compressedDy?: string | number,
	compressedWidth = 360,
): string {
	const { width, height } = originalSize;

	if (!width || !height || !compressedDy) return '0';

	const compressedHeight = (compressedWidth / width) * height;
	const dy = typeof compressedDy === 'string' ? parseFloat(compressedDy) : compressedDy;

	const originalDy = (dy / compressedHeight) * height;

	return originalDy.toFixed(2);
}
